module.exports = __webpack_public_path__ + "static/media/image_15.239223e8.png";